export default __webpack_public_path__ + "static/media/logo.193d1e60.svg";